<template>
  <div class="table-row">

    <span v-if="isToggled && allowEdit" @click="openAdditionalDetail(item.id)"
      class="edit-icon i-util-settings"></span>
    
    <div class="toggler">
      <v-chevron v-model="isToggled"/> 
    </div>

    <div v-if="!isToggled" class="header">
      <div @click="toggle" :title="item.name"
        class="name item w1">{{ item.name | shortstr }}</div>
      <div class="item w2" :title="item.company_name">
        {{ item.company_name | shortstr }}</div>
    </div>

    <div v-else class="body">

      <div class="body-row first">
        <div class="item w1">
          <div class="title">{{ 'base.farm_name' | translate }}:</div>
          <div class="value">{{ item.name }}</div>
        </div>
        <div class="item w1">
          <div class="title">{{ 'base.company' | translate }}:</div>
          <div class="value">{{ item.company_name }}</div>
        </div>
        <div class="item w1">
          <div class="title">{{ 'base.ind_code' | translate }}:</div>
          <div class="value">{{ item.ind_code }}</div>
        </div>
      </div>

      <div class="body-row dark">
        <div class="item w1">
          <div class="title">{{ 'base.struct' | translate }}:</div>
          <div class="value">{{ item.structure_name }}</div>
        </div>
        <div class="item w1">
          <div class="title">{{ 'base.farm' | translate }}:</div>
          <div class="value">{{ item.farm_full_name }}</div>
        </div>
        <div class="item w1">
          <div class="title">{{ 'base.destination' | translate }}:</div>
          <div class="value">{{ item.appoint }}</div>
        </div>
      </div>

      <div class="body-row">
        <div class="item w3">
          <div class="title">{{ 'base.struct_manager' | translate }}:</div>
          <div class="value">{{ item.structure_manager }}</div>
        </div>
        <div class="item w3">
          <div class="title">{{ 'base.farm_manager' | translate }}:</div>
          <div class="value">{{ item.farm_manager }}</div>
        </div>
        <div class="item w3">
          <div class="title">{{ 'base.zootechnic' | translate }}:</div>
          <div class="value">{{ item.zootechnics }}</div>
        </div>
        <div class="item w3">
          <div class="title">{{ 'base.accountant' | translate }}:</div>
          <div class="value">{{ item.accountant }}</div>
        </div>
        <div class="item w3">
          <div class="title">{{ 'base.weigher' | translate }}:</div>
          <div class="value">{{ item.weigher }}</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'BlankItem',

  props: {
    item: Object
  },

  data: () => ({
    isToggled: false
  }),

  methods: {
    ...mapActions('additional', [
      'openAdditionalDetail'
    ]),

    toggle () {
      this.isToggled = !this.isToggled
    }
  },

  computed: {
    allowEdit () {
      return this.hasPermission('additional', 'change')
    }
  }
}
</script>

<style scoped>
  .item {
    padding: 0 10px;
  }

  .edit-icon {
    cursor: pointer;
    position: absolute;
    right: 55px;
    top: 12px;
  }

  .w1 { width: 50%; }
  .w2 { width: 50%; }

  .table-row {
    position: relative;
    border-radius: 10px;
    background: #fff;
    overflow: hidden;
  }

  .table-row .header {
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 10px;
  }

  .table-row .toggler {
    position: absolute;
    top: 12px;
    right: 20px;
  }

  .table-row .header .item {
    font-size: 16px;
  }

  .header .name {
    cursor: pointer;
  }

  .table-row .body-row {
    display: flex;
    padding: 25px 10px;
  }

  .table-row .body-row.first {
    padding: 15px 10px;
    margin-bottom: 10px;   
  }

  .table-row .body-row.dark {
    background: #F5F5F5;
  }

  .table-row .body .title {
    height: 30px;
    color: #979797;
    font-size: 13px;
    
    margin-bottom: 13px;
  }

  .table-row .body .value {
    font-size: 15px;
  }
</style>
